import request from '@/services/interceptor.js'



// Utente
export const get_datiUserInfo = () => {
    return request({
        url: '/user/info',
        method: 'get',
        loadingBar: true
    })
};

export const heartbeat = () => {
    return request({
        url: '/user/heartbeat',
        method: 'post',
        loadingBar: false
    })
}